module.exports = __webpack_public_path__ + "2de1d9115aabd39e3ef31cda8732ebc8.jpg";